import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ApiMethod } from '../apimethods/api-method';
import { customfunctions } from '../common/customfunctions';
import { GlobalConstants } from '../common/global-constants';
import { QuickSearchComponent } from '../quick-search/quick-search.component';
import * as ngswal from "sweetalert";
import { DataAccess } from '../common/dataaccess.service';
declare var $;

@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.css']
})
/** site-layout component*/
export class SiteLayoutComponent implements OnInit {
  /** site-layout ctor */
  currentYear = new Date().getFullYear();
  LoginName: string = localStorage.aLoginName;
  homeIndex = localStorage.indexPage;
  public links = JSON.parse(localStorage.aMenuList);
  public links1 = JSON.parse(localStorage.aMenuList);
  userRoleList;
  roleListShow: boolean = false;
  activeRoleId = localStorage.roleId;
  ThemesList;
  showModalCO: boolean; PageHeading: string;
  topIconHide: string = localStorage.hideTopIcon;
  expressflow: string = localStorage.xflow;
  grammrflow: string = "false";
  notificationCount: string;
  manualCurrentUser;
  hideTopMenu: string = 'false';
  showAccessModal: boolean;
  AccessModaltitle: string;
  multiPublist: string = localStorage.multiPublist;
  Logintype = localStorage.LoginType;
  showPopUpNotification: boolean;
  popupNotificationId: string;
  _eptArticleNo: string;
  biomedPrdData = false;
  constructor(private router: Router, private renderer: Renderer2, private dataAccess: DataAccess) {
    var menuList = JSON.parse(localStorage.aMenuList);
    $('#imgnGrammr').hide();
    localStorage.pasteHtmlClear = 'false';
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.PageHeading = this.router.url.replace("/", "").split('?')[0];

        //Validate Component Access By Role
        if (this.PageHeading != 'author-ept' && this.PageHeading != 'editor-ept' && this.PageHeading != 'exception'
          && this.PageHeading != 'proofing-ept' && this.PageHeading != 'quick-search'
          && this.PageHeading != 'notification' && this.PageHeading != 'user-profile'
          && this.PageHeading != 'aps-staff-portal' && this.PageHeading != 'field-update'
          && this.PageHeading != 'freelancer-index' && this.PageHeading != 'freelancer-onboard'
          && this.PageHeading != 'nedit') {

          var checkAccessPage = menuList.filter(a => a.LinkPath == this.PageHeading);
          if (checkAccessPage.length == 0) {
            this.router.navigate(['login']);
          }
        }

        let biomedPrd = menuList.filter(a => a.MenuName == "BioMedProduction");
        if (biomedPrd.length > 0) {
          this.biomedPrdData = true;
          customfunctions.SetTodayDateValues("#TxtBioMedDate");
        }


        this.hideTopMenu = 'false'; $('.dropdown-divider').show();
        switch (this.PageHeading) {
          case 'home': case 'prd-mgr': case 'prd-staff': case 'prd-sup':
            this.PageHeading = 'Dashboard';
            return;
          case 'vendor-index':
            this.PageHeading = 'Vendor Dashboard';
            return;
          case 'ingestion':
            this.PageHeading = 'Ingestion & UCC';
            return;
          case 'journals':
            this.PageHeading = 'Journal Settings';
            return;
          case 'publisher-master':
            this.PageHeading = 'Publisher Settings';
            return;
          case 'defect-mgt':
            this.PageHeading = 'Defect Management';
            return;
          case 'cc3-centralized-system':
            this.PageHeading = ''; this.hideTopMenu = 'true';
            let appLogo = $('#imgAppLogo').attr('src').replace('logo-dark', 'nLogic');
            $('#imgAppLogo').attr('height', "50px");
            $('#imgAppLogo').attr('src', appLogo);
            $('.dropdown-divider').hide();
            this.grammrflow = "true";
            return;
          case 'eg-home':
            this.PageHeading = "";
            this.hideTopMenu = 'true'; $('.dropdown-divider').hide();
            return;
          case 'nedit':
            this.PageHeading = 'nEdit Dashboard';
            this.hideTopMenu = 'true'; $('.dropdown-divider').hide();
            return;
          case 'osa-staff-portal': case 'aps-staff-portal':
            this.PageHeading = this.PageHeading.replace(/\-/g, ' ');
            this.hideTopMenu = 'true'; $('.dropdown-divider').hide();
            return;
          case 'pra-review':
            this.PageHeading = 'Client Review';
            this.hideTopMenu = 'true'; $('.dropdown-divider').hide();
            return;
          case 'pra-tat':
            this.PageHeading = 'PRA TAT Process';
            return;
          case 'proofing-ept':
            this.PageHeading = 'Proofing Ept';
            this.hideTopMenu = 'true'; $('.dropdown-divider').hide();
            return;
          case 'employee-profiling':
            this.PageHeading = 'Employee Profiling';
            this.hideTopMenu = 'true'; $('.dropdown-divider').hide();
            return;
          case 'author-ept':
            this.PageHeading = 'Author Proofing';
            this.hideTopMenu = 'true'; $('.dropdown-divider').hide();
            return;
          case 'editor-ept':
            this.PageHeading = 'Editor Proofing';
            this.hideTopMenu = 'true'; $('.dropdown-divider').hide();
            return;
          case 'proofing-config':
            this.PageHeading = 'Proofing Configuration';
            return;
          case 'pra-services':
            this.PageHeading = 'Peer Review Admin Services';
            return;
          case 'ttp-report':
            this.PageHeading = 'Reports';
            return;
          case 'home-index':
            this.PageHeading = '';
            return;
          default:
            this.PageHeading = this.PageHeading.replace(/\-/g, ' ');
            return;
        }
      }
    });


    this.renderer.listen('window', 'click', (e: Event) => {
      try {
        $('form,input,textarea').attr('autocomplete', 'off');
        let codiv = $(e.target).attr('class');
        let coBtn = $(e.target).closest("button").attr('id');
        let topMenuCt = $(e.target).closest(".dropdown").length;

        if (topMenuCt == 0 && codiv != 'manualCurrentUser') {
          $('.dropdown-menu').removeClass('show');
        }

        if ($(e.target).attr('id') != 'btnColOption' && $(e.target).attr('id') != 'btnShowCO' && $(e.target).attr('id') != 'btnCOApply'
          && coBtn != 'btnColOption' && coBtn != 'btnShowCO' && coBtn != 'btnCOApply' && codiv != 'chkCOAction' && codiv != 'fa fa-wrench'
          && codiv != 'spAddIcon' && codiv != 'col divCOList' && codiv != 'manualCurrentUser') {
          this.hideCO();
        }
      } catch (e) {
        console.log(e);
      }

    });
  }


  ngOnInit() {
    this.links = JSON.parse(localStorage.aMenuList);
    this.links1 = JSON.parse(localStorage.aMenuList);
    this.ThemesList = JSON.parse(localStorage.athemesList);
    if (localStorage.aImgLogo != null && localStorage.aImgLogo.trim() != '') {
      $('#imgUserLogo').attr('src', localStorage.aImgLogo);
    }
    $('.main-sidebar').css('height', (GlobalConstants.size.height) + 158);
    $('#divitemList').css('height', GlobalConstants.size.height + 30);
    $('#divCOList').css('height', GlobalConstants.size.height - 240);

    this.userRoleList = JSON.parse(localStorage.roleList);
    if (this.userRoleList.length > 1) {
      this.roleListShow = true;
    }
    this.activeRoleId = localStorage.roleId;
    this.loadNotification();
    this.loadPopupNotification();
    setInterval(function () {
      $('#btnNotifyList').trigger('click');
    }, 1000000);

    this.dataAccess.getEptArticleNo.subscribe(value => this._eptArticleNo = value);
  }

  ngAfterViewInit(): void {
    customfunctions.SetTheme(localStorage.UserThemes, true);
    this.ShowHeaderButtonClickPopup();
  }

  ngAfterViewChecked(): void {
    $('input[type="date"]').on("keydown", function () {
      return false;
    });
    this.dataAccess.setEptArticleNo(this._eptArticleNo);
  }

  activeFunc() {
    $("li").removeClass("active current-page");
    var currentSelectedli = $("a.router-link-exact-active").parent('li');
    currentSelectedli.addClass("current-page");
    currentSelectedli.siblings().removeClass("active current-page");
    var parentLI = currentSelectedli.parent("ul").parent("li"); if (parentLI.length != 0) {
      parentLI.addClass("active");
    }
  }

  UserLogout() {
    let loginMode = GlobalConstants.isNullCheck(localStorage.LoginType);
    if (loginMode.indexOf('authorproof') > 0) {
      window.location.href = '/login?type=' + loginMode;
    }
    else {
      this.router.navigate(['/login'], { queryParams: { type: loginMode } });
    }
  }

  ShowCO() {
    this.showModalCO = true;
  }

  hideCO() {
    this.showModalCO = false;
  }

  treeviewinit() {
    $('[data-widget="treeview"]').Treeview('init');
  }

  UpdateCO(type) {
    let chkList = $('input.chkCOAction');
    let ColumnList = [];
    $(chkList).each(function (index) {
      ColumnList.push({
        ColumnTitle: $(this).attr('name'),
        Visible: $(this).is(':checked')
      });
    });
    let modulename = localStorage.mdName;
    if (modulename != '') {
      var aitemL = {
        LoginID: localStorage.aLoginID,
        PublisherID: localStorage.aPubID,
        ModuleName: modulename,
        OrderList: null,
        VisibleList: JSON.stringify(ColumnList),
        UpdateType: type
      };
      ApiMethod.postMethod('gen/updatecolumnorder', aitemL).subscribe(
        resonse => {
          this.hideCO();
          $('#btnLoadList').trigger('click');
          console.log(resonse);
        },
        error => {
          console.log(error);
        }
      );
    }
  }

  SetTheme(themeName): void {
    customfunctions.SetTheme(themeName);
  }

  changeAccessRole(roleId, trigger = false): void {
    if (trigger) {
      $("#LoadingImage").show();
      var userItem = {
        RoleId: roleId
      };
      ApiMethod.postMethod("api/menuaccessList", userItem).subscribe(
        resonse => {
          let aMenuList = resonse.aMenuAccessList;
          localStorage.aMenuList = JSON.stringify(aMenuList);
          localStorage.roleId = roleId;
          $('.roleList.activeRole').removeClass('activeRole');
          $('#spRole' + roleId).addClass('activeRole');
          this.reloadComponent();
          $("#LoadingImage").hide();
        },
        error => {
          console.error(error)
          $("#LoadingImage").hide();
        }
      );
    }
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  GetSearchData() {
    this.router.navigate(['/quick-search']);
    QuickSearchComponent.loadSearchDataList();
  }

  ShowHeaderButtonClickPopup() {
    $('.dropdown-menu').removeClass('show');
    $('.dropdown button,.dropdown li').on('click', function () {
      let divDrop = $(this).closest(".dropdown");
      let checkOpen = $(divDrop).find('.dropdown-menu').hasClass("show");
      if (checkOpen == false)
        $(divDrop).find('.dropdown-menu').addClass('show');
      else
        $('.dropdown-menu').removeClass('show');
    });


    $('li.dropdown').on('click', function () {
      if (!window.matchMedia('(min-width: 992px)').matches) {
        let checkOpen = $(this).find('.dropdown-menu.show').hasClass("show");
        if (checkOpen == false)
          $(this).find('.dropdown-menu').addClass('show');
        else
          $(this).find('.dropdown-menu').removeClass('show');
      }
    });

  }

  loadPopupNotification() {
    var notificationdata = {
      RoleId: localStorage.roleId,
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };
    this.popupNotificationId = '';
    ApiMethod.postMethod("api/GetPopUpNotification", notificationdata).subscribe(
      result => {
        var notificationList = result.notificationList;


        $("#tblPopUpNotification tbody").html("");

        if (notificationList.length != 0) {
          var nRowL = "";
          for (var i = 0; i < notificationList.length; i++) {
            this.popupNotificationId = this.popupNotificationId + notificationList[i].Id + ','
            nRowL += "<tr>";
            nRowL += "<td>" + (i + 1).toString() + "</td>";
            nRowL += "<td>" + notificationList[i].Acronym + "</td>";
            nRowL += "<td>" + notificationList[i].Title + "</td>";
            nRowL += "<td>" + notificationList[i].Description + "</td>";
            nRowL += "</tr>";
            $("#tblPopUpNotification tbody").append(nRowL);
            this.showPopUpNotification = true;
          }

        }

      }, error => {
        console.log(error);
      });
  }

  ReadPopUpNotification() {
    var notificationdata = {
      LoginId: localStorage.aLoginID,
      PopupNotificationID: this.popupNotificationId
    };

    ApiMethod.postMethod("api/ReadPopupNotification", notificationdata).subscribe(
      result => {
        if (result.isRead) {
          ngswal("Succes !", "Notification read successfully !", "success");
          this.showPopUpNotification = false;
        } else {
          ngswal("Failed !", "Try after sometimes !", "warning");
        }
      }, error => {
        console.log(error);
      });
  }

  loadNotification() {
    var notificationdata = {
      RoleId: localStorage.roleId,
      LoginId: localStorage.aLoginID
    };

    ApiMethod.postMethod("api/GetNotification", notificationdata).subscribe(
      result => {
        var notificationList = result.notificationList;
        this.notificationCount = result.unreadCount;
        this.manualCurrentUser = result.manualUserList;
        if (this.notificationCount == "0") {
          $('#spCount').html('');
          $('#ibellAnimate').removeClass('bx-tada');
        }
        else {
          $('#spCount').html(result.unreadCount);
          //$('#ibellAnimate').addClass('bx-tada');
        }


        localStorage.notificationId = 0;

        $("#divNotification").html('');
        var zTableList = "";
        $.each(notificationList, function (e, val) {
          zTableList += "<a href='javascript: void(0);' class='text-reset notification-item'><div class='d-flex'>";
          zTableList += "<div class='avatar-xs me-3'><span class='avatar-title bg-primary rounded-circle font-size-16'><i class='bx bx-task'></i></span></div>";
          zTableList += "<div class='flex-grow-1'><h6 class='mb-1' key='t-your-order'>" + val.Title + "</h6><div class='font-size-12 text-muted'>";
          if (val.isRead)
            zTableList += "<span style='float:right;'><input type='checkbox' checked disabled='disabled' style='cursor:pointer'></span>";
          else
            zTableList += "<span style='float:right;'><input type='checkbox' style='cursor:pointer' onclick=localStorage.notificationId='" + val.Id + "';$('#spUpdateNotification').trigger('click');></span>";
          zTableList += "<p class='mb-1' key='t-grammer' style='width:85%'>" + val.Description + "</p>";
          zTableList += "<p class='mb-0'><i class='mdi mdi-clock-outline'></i> <span key='t-min-ago'>" + val.TimeAgo + "</span></p></div></div>";
          zTableList += "</div></a>";
        });
        $("#divNotification").append(zTableList);

        //Update notification UI
        var TableList = '<div class="DivList"><table width="100%">';
        $.each(notificationList, function (e, val) {
          TableList += '<tr style="background-color: #e6e9ff;border-bottom: #888888 2px solid;" for="chk_' + val.Id + '">';
          TableList += '<td>';
          TableList += '<div class="row divDataItem" style="padding: 8px;">';
          TableList += '<div class="col-sm-12 child"><strong>' + 'Title : ' + val.Title + '</strong></div>';
          TableList += '<div class="col-sm-4 divPadd">' + 'Description : ' + val.Description + '</div>';
          TableList += '<div class="col-sm-4 divPadd" title=' + GlobalConstants.FormatDate(val.CreatedTime) + '>' + 'TimeAgo : ' + val.TimeAgo + '</div>';

          if (val.isRead)
            TableList += '<div class="col-sm-4 divPadd"><span><input type="checkbox" id="chk_' + val.Id + '" checked disabled="disabled" style="cursor: pointer"></span></div>';
          else
            TableList += '<div class="col-sm-4 divPadd"><span><input type="checkbox" id="chk_' + val.Id + '" style="cursor: pointer" onclick=localStorage.notificationId="' + val.Id + '";$("#spReadNotification").trigger("click");></span></div>';

          TableList += '</td></tr>';
        });

        TableList += '</table></div>';
        $('#notificationList').html(TableList);

      }, error => {
        console.log(error);
      });
  }

  updateNotification() {
    var notificationdata = {
      Id: localStorage.notificationId,
      LoginId: localStorage.aLoginID,
      RoleId: localStorage.roleId
    };

    ApiMethod.postMethod("api/UpdateNotification", notificationdata).subscribe(
      result => {
        if (result.isRead) {
          ngswal("Succes !", "Notification read successfully !", "success");
          this.loadNotification();
        } else {
          ngswal("Failed !", "Try after sometimes !", "warning");
        }
      }, error => {
        console.log(error);
      });
  }

  pubsList_AccessModal: any; currentPubsId: any;
  rolesList_AccessModal: any; currentRolesId: any;
  // Change Role Data 
  GetAccessRole() {
    var AccessData = {
      RoleId: localStorage.roleId,
      LoginId: localStorage.aLoginID
    }
    ApiMethod.postMethod("api/profile", AccessData).subscribe(
      result => {
        this.rolesList_AccessModal = result.roleList;
        this.currentRolesId = localStorage.roleId;
        this.pubsList_AccessModal = result.pubList;
        this.currentPubsId = localStorage.aPubID;
      })
    $('#AccessModal').show();
    this.showAccessModal = true;
    this.AccessModaltitle = "Change Publisher & Role";
  }
  HideAccessModal() {
    $('#AccessModal').hide();
  }

  ChangeAccessPubOrRole(): void {
    $("#LoadingImage").show();


    var dataItem = {
      UserID: localStorage.aLoginID,
      RoleID: $('#ddlRolesListAM').val()
    };

    ApiMethod.postMethod("api/UserChangeRoleId", dataItem).subscribe(
      result => {

        ngswal({
          position: 'top-end',
          type: "success",
          title: "Updated !",
          text: 'Access Changes Updated',
          showConfirmButton: false,
          timer: 1500
        });

        localStorage.aPubID = $('#ddlPubsListAM').val();
        localStorage.roleId = $('#ddlRolesListAM').val();

        console.log(result);

        this.HideAccessModal();
        location.reload();

      }, error => {
        console.log(error);
        $("#LoadingImage").hide();
      });

  }

  showPrdModal: boolean;
  ShowPrdReport() {
    this.showPrdModal = true;
  }

  hidePrd() {
    this.showPrdModal = false;
  }
  GetProductionData() {
    $("#LoadingImagePopup1").show();
    let data = {
      LoginId: localStorage.aLoginID,
      FromDate: $('#TxtBioMedDate').val(),
      ToDate: $('#TxtBioMedDate').val(),
    }
    ApiMethod.postMethod('api/GetBioMedProductionReport', data).subscribe(
      result => {

        let dataVal = result.dataList;
        let dataList = dataVal.sort((a, b) => a.UserName.localeCompare(b.UserName));
        let empList = Array.from(
          new Map(dataList.map(item => [item.UserName, item])).values()
        );

        let _dynamicCols = dataVal.sort((a, b) => a.Volume.localeCompare(b.Volume));
        let dynamicCols = Array.from(
          new Map(_dynamicCols.map(item => [item.Volume, item])).values()
        );

        let thCenter = 'style="text-align: center;vertical-align: middle;border: solid 1px;"';
        let thCenterColor = 'style="text-align: center;vertical-align: middle;border: solid 1px;background: #0b2f8d !important;color:#FFF;"';
        let tdBorder = 'style="vertical-align: middle;border: solid 1px;background: #0b2f8d !important;color:#FFF;"';
        let tdBorder1 = 'style="vertical-align: middle;border: solid 1px;background: #0b2f8d !important;color:#FFF;white-space:nowrap !important;"';

        let trEmpList = '<div class="fixTableHead" id="divTableList" style="overflow-y: auto;height: 110px;">';
        trEmpList += '<table class="table" style="font-size:12px;">';
        trEmpList += '<thead>';

        //First Column List
        trEmpList += '<tr>';
        trEmpList += `<th ${tdBorder} rowspan="2">SNo</th>`;
        trEmpList += `<th ${tdBorder} rowspan="2">Name</th>`;
        trEmpList += `<th ${tdBorder1} rowspan="2">Total</th>`;

        let currentTask = [];
        let _prevData = '';
        //Dynamic Columns
        $.each(dynamicCols, function (e, val) {
          let _colData = val.PublisherCode;
          let _thCenterColor = thCenterColor;
          if (_prevData != _colData) {
            _thCenterColor = _thCenterColor.replace('#0b2f8d', 'green');
            currentTask.push({ Volume: val.Volume, PublisherCode: val.PublisherCode });
          }
          trEmpList += `<th ${_thCenterColor} colspan="3">`;
          trEmpList += `${val.PublisherCode} <br/> ${val.Volume}`;
          trEmpList += '</th>';

          _prevData = val.PublisherCode;
        });
        //Dynamic Columns

        trEmpList += '</tr>';
        //First Column List


        trEmpList += '<tr>';
        $.each(dynamicCols, function (e, val) {
          let _checkCurrent = currentTask.filter(a => a.Volume == val.Volume && a.PublisherCode == val.PublisherCode);
          let _thCenterColor = thCenterColor;
          if (_checkCurrent.length > 0) {
            _thCenterColor = _thCenterColor.replace('#0b2f8d', 'green');
          }
          trEmpList += `<th ${_thCenterColor}>Inhouse (Pages)</th>`;
          trEmpList += `<th ${_thCenterColor}>QC (Pages)</th>`;
          trEmpList += `<th ${_thCenterColor}>Image (Count)</th>`;
        });
        trEmpList += '</tr>';
        //Dynamic Columns
        trEmpList += '</thead>';

        trEmpList += '<tbody>';
        $.each(empList, function (e, val) {

          let _empArtCt = dataVal
            .filter(a => a.UserName === val.UserName)
            .reduce((total, item) => total + Number(item.ArticleCount || 0), 0);

          let _empArtPage = dataVal
            .filter(a => a.UserName === val.UserName)
            .reduce((total, item) => total + Number(item.Pages || 0), 0);


          trEmpList += '<tr>';
          trEmpList += `<td ${tdBorder}>${e + 1}</td>`;
          trEmpList += `<td ${tdBorder}>${val.UserName}</td>`;
          trEmpList += `<td ${tdBorder1}>${_empArtCt} (${_empArtPage})</td>`;

          $.each(dynamicCols, function (e1, val1) {
            let _InHouseVal = dataVal.filter(a => a.UserName == val.UserName && a.Volume == val1.Volume && a.TaskType == 'InHouse');
            if (_InHouseVal.length > 0) {
              trEmpList += `<td ${thCenter}>${_InHouseVal[0].ArticleCount} (${_InHouseVal[0].Pages})</td>`;
            }
            else {
              trEmpList += `<td ${thCenter}>--</td>`;
            }

            let _QcVal = dataVal.filter(a => a.UserName == val.UserName && a.Volume == val1.Volume && a.TaskType == 'QC');
            if (_QcVal.length > 0) {
              trEmpList += `<td ${thCenter}>${_QcVal[0].ArticleCount} (${_QcVal[0].Pages})</td>`;
            }
            else {
              trEmpList += `<td ${thCenter}>--</td>`;
            }

            let _IpVal = dataVal.filter(a => a.UserName == val.UserName && a.Volume == val1.Volume && a.TaskType == 'ImageProcess');
            if (_IpVal.length > 0) {
              trEmpList += `<td ${thCenter}>${_IpVal[0].ArticleCount} (${_IpVal[0].Pages})</td>`;
            }
            else {
              trEmpList += `<td ${thCenter}>--</td>`;
            }

          });

          trEmpList += '</tr>'
        });

        trEmpList += '</tbody>';

        trEmpList += '</div>';


        trEmpList += '</table>';

        $('#divPrdDataList').html(trEmpList);

        $('#divTableList').css('height', (GlobalConstants.size.height - 100));
        $("#LoadingImagePopup1").hide();
      }, error => {
        $("#LoadingImagePopup1").hide();
        console.log(error);
      }
    );
  }
}
